import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorInfo, RenderingState } from 'redux/types';
import { RootState } from 'redux/root-reducer';

export const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

export const updateProfileInfoSlice = createSlice({
  name: 'UPDATE_PROFILE',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = false;
      state.error.message = '';
      state.error.statusCode = null;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error.message = action.payload.message;
      state.error.statusCode = action.payload.statusCode;
    },
    resetToInitials: (state) => {
      state.isLoading = initialState.isLoading;
      state.success = initialState.success;
      state.error = initialState.error;
    },
  },
});

// REDECER
export default updateProfileInfoSlice.reducer;

// ACTIONS
export const {
  loading,
  success,
  failure,
  resetToInitials,
} = updateProfileInfoSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.user.updateProfileInfo.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.user.updateProfileInfo.success;
export const selectError = (state: RootState) => state.ui.user.updateProfileInfo.error;
